import { render, staticRenderFns } from "./DigitalFranchisePurchaseList.vue?vue&type=template&id=56cd6e2a&scoped=true"
import script from "./DigitalFranchisePurchaseList.vue?vue&type=script&lang=js"
export * from "./DigitalFranchisePurchaseList.vue?vue&type=script&lang=js"
import style0 from "./DigitalFranchisePurchaseList.vue?vue&type=style&index=0&id=56cd6e2a&prod&lang=scss&scoped=true"
import style1 from "./DigitalFranchisePurchaseList.vue?vue&type=style&index=1&id=56cd6e2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd6e2a",
  null
  
)

export default component.exports